import { useState } from 'react';
import Navbar from '../../components/feature/Navbar';

export default function Whitepaper() {
  const [showShareModal, setShowShareModal] = useState(false);
  const [showEmailModal, setShowEmailModal] = useState(false);
  const [email, setEmail] = useState('');
  const [emailSent, setEmailSent] = useState(false);
  const [shareSuccess, setShareSuccess] = useState(false);
  const [isGeneratingPDF, setIsGeneratingPDF] = useState(false);

  const sections = [
    {
      title: 'Executive Summary',
      content:
        "PepCoin isn't just another cryptocurrency – it's a complete financial revolution. By fusing cutting-edge AI automation with blockchain immutability and immersive 3D experiences, we're creating an ecosystem where wealth creation becomes effortless, intelligent, and accessible to everyone.",
    },
    {
      title: 'Technology Stack',
      content:
        "Built on a lightning-fast EVM-compatible blockchain processing 100,000+ TPS with near-zero fees. Our AI engine harnesses deep learning neural networks for market prediction, risk assessment, and automated portfolio optimization. Smart contracts audited by CertiK and Quantstamp ensure bulletproof security.",
    },
    {
      title: 'Tokenomics',
      content:
        "PEP token features a revolutionary deflationary model: 50% of transaction fees auto-burned, creating scarcity. Stake for 8-15% APR with flexible lock periods. Governance rights let holders shape the future. Total supply capped at 1 billion tokens with transparent, community-first distribution.",
    },
    {
      title: 'AI Trading System',
      content:
        "PepBot is your 24/7 Wall Street analyst – analyzing millions of data points per second, predicting market movements with 94% accuracy, and executing trades in milliseconds. Machine learning algorithms continuously improve, adapting to market conditions faster than any human trader.",
    },
    {
      title: 'P2P & Payment Gateway',
      content:
        "Trade directly with users worldwide through our escrow-protected P2P marketplace supporting 150+ payment methods. Our payment gateway lets businesses accept crypto instantly with auto-conversion to fiat, HD wallet security, and real-time notifications. Enterprise-grade infrastructure, startup-simple integration.",
    },
    {
      title: 'Security Framework',
      content:
        "Military-grade protection with multi-layer encryption, biometric authentication, hardware wallet integration, and AI-powered fraud detection. Smart contracts undergo rigorous audits. Cold storage for 95% of funds. Bug bounty program with $1M+ rewards. Your assets are safer than Fort Knox.",
    },
    {
      title: 'Roadmap',
      content:
        "Five-phase masterplan: Q1 2024 - Blockchain foundation & token launch. Q2 - Core wallet & staking. Q3 - AI trading engine & P2P marketplace. Q4 - Payment gateway & 3D dashboard. 2025 - PepVerse metaverse expansion with virtual real estate, NFT marketplace, and immersive social experiences.",
    },
  ];

  const generateTextFile = () => {
    setIsGeneratingPDF(true);
    
    try {
      const content = `
PepCoin Whitepaper
The Future of AI-Powered Cryptocurrency
Version 1.0 | ${new Date().toLocaleDateString()}

===============================================

TABLE OF CONTENTS

${sections.map((section, index) => `${index + 1}. ${section.title}`).join('\n')}

===============================================

${sections.map((section, index) => `
${index + 1}. ${section.title.toUpperCase()}

${section.content}

${section.title === 'Tokenomics' ? `
TOKEN DISTRIBUTION:
• Public Sale: 40% (400M PEP)
• Staking Rewards: 25% (250M PEP)
• Team & Development: 15% (150M PEP)
• Liquidity Pool: 10% (100M PEP)
• Marketing & Partnerships: 10% (100M PEP)

KEY METRICS:
• Total Supply: 1,000,000,000 PEP
• Transaction Fee: 1% (50% burned)
• Staking APR: 8-15%
• Lock Periods: Flexible (7-365 days)
• Governance: Token holder voting
` : ''}

${section.title === 'Technology Stack' ? `
CORE TECHNOLOGIES:
• Blockchain: EVM-compatible with 100,000+ TPS
• Consensus: Proof of Stake with validator nodes
• AI Engine: Deep learning neural networks
• Frontend: React, WebGL, Three.js for 3D visualization
• Backend: Node.js microservices, Python AI models
• Smart Contracts: Solidity, Web3.js integration
• Security: Multi-layer encryption, biometric authentication
• Storage: IPFS for decentralized file storage
` : ''}

${section.title === 'AI Trading System' ? `
PEPBOT FEATURES:
• Real-time market analysis (1M+ data points/second)
• Predictive accuracy: 94% success rate
• Risk management: Dynamic stop-loss algorithms
• Portfolio optimization: AI-driven asset allocation
• Sentiment analysis: Social media & news integration
• Automated execution: Sub-millisecond trade execution
• Machine learning: Continuous strategy improvement
• Multi-exchange support: 50+ trading platforms
` : ''}

${section.title === 'P2P & Payment Gateway' ? `
P2P FEATURES:
• Smart Contract Escrow
• 150+ Payment Methods
• Reputation System
• Dispute Resolution

PAYMENT GATEWAY:
• HD Wallet Addresses
• Auto Fiat Conversion
• Real-time Notifications
• API Integration
` : ''}

===============================================
`).join('\n')}

EXECUTIVE LEADERSHIP

CEO: Apostle Edesemi Friday
CTO: Paul Bolu-ebi E.
CFO: Precious Tariebi E.
CMO: Douebi Peace E.

LEADERSHIP VALUES:
• Innovation: Pioneering blockchain solutions
• Integrity: Transparent and ethical leadership
• Community: Building strong partnerships
• Growth: Continuous improvement

===============================================

CONTACT & RESOURCES

Website: https://pepcoin.io
Email: info@pepcoin.io
Telegram: @PepCoinOfficial
Twitter: @PepCoinAI
GitHub: https://github.com/pepcoin
Discord: https://discord.gg/pepcoin

© 2024 PepCoin. All rights reserved.
      `;
      
      const blob = new Blob([content], { type: 'text/plain;charset=utf-8' });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = 'PepCoin-Whitepaper-v1.0.txt';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error generating file:', error);
      alert('Download failed. Please try again or contact support.');
    } finally {
      setIsGeneratingPDF(false);
    }
  };

  const handleDownloadPDF = () => {
    generateTextFile();
  };

  const handleShare = (platform: string) => {
    const url = window.location.href;
    const title = 'PepCoin Whitepaper - The Future of AI-Powered Cryptocurrency';
    const description = 'Discover PepCoin\'s revolutionary blockchain technology with AI automation, smart trading, P2P marketplace, and DeFi ecosystem. Read the complete technical whitepaper now!';
    const hashtags = 'PepCoin,Cryptocurrency,AI,Blockchain,DeFi,Whitepaper';

    let shareUrl = '';
    switch (platform) {
      case 'twitter':
        // Twitter with proper text formatting and encoding
        const twitterText = `📄 ${title}\n\n${description}\n\n🔗 Read now: ${url}\n\n#${hashtags.replace(/,/g, ' #')}`;
        shareUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(twitterText)}`;
        break;
      case 'facebook':
        // Facebook with simple URL sharing
        shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`;
        break;
      case 'linkedin':
        // LinkedIn with proper parameters
        shareUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`;
        break;
      case 'telegram':
        // Telegram with simple text and URL
        const telegramText = `📄 ${title}\n\n${description}\n\n🔗 ${url}`;
        shareUrl = `https://t.me/share/url?url=${encodeURIComponent(url)}&text=${encodeURIComponent(telegramText)}`;
        break;
      case 'whatsapp':
        // WhatsApp with formatted message
        const whatsappText = `📄 *${title}*\n\n${description}\n\n🔗 ${url}`;
        shareUrl = `https://api.whatsapp.com/send?text=${encodeURIComponent(whatsappText)}`;
        break;
      case 'reddit':
        // Reddit with title and URL
        shareUrl = `https://www.reddit.com/submit?url=${encodeURIComponent(url)}&title=${encodeURIComponent(title)}`;
        break;
      case 'copy':
        // Copy formatted text with URL
        const copyText = `${title}\n\n${description}\n\n🔗 ${url}`;
        navigator.clipboard.writeText(copyText).then(() => {
          setShareSuccess(true);
          setTimeout(() => setShareSuccess(false), 2000);
        }).catch(() => {
          // Fallback for older browsers
          const textArea = document.createElement('textarea');
          textArea.value = copyText;
          document.body.appendChild(textArea);
          textArea.select();
          document.execCommand('copy');
          document.body.removeChild(textArea);
          setShareSuccess(true);
          setTimeout(() => setShareSuccess(false), 2000);
        });
        return;
    }

    if (shareUrl) {
      // Open in new window with proper dimensions and features
      const width = 600;
      const height = 600;
      const left = Math.max(0, (window.screen.width - width) / 2);
      const top = Math.max(0, (window.screen.height - height) / 2);
      
      try {
        const popup = window.open(
          shareUrl, 
          'share_popup', 
          `width=${width},height=${height},left=${left},top=${top},scrollbars=yes,resizable=yes,toolbar=no,menubar=no,location=no,status=no`
        );
        
        // Check if popup was blocked
        if (!popup || popup.closed || typeof popup.closed === 'undefined') {
          // Fallback: open in same tab
          window.open(shareUrl, '_blank');
        }
      } catch (error) {
        // Final fallback: copy link instead
        console.error('Share failed:', error);
        navigator.clipboard.writeText(url).then(() => {
          alert('Sharing failed, but link copied to clipboard!');
        }).catch(() => {
          alert('Sharing failed. Please copy this link manually: ' + url);
        });
      }
    }
  };

  const handleEmailSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (email) {
      // Simulate email sending
      setEmailSent(true);
      setTimeout(() => {
        setShowEmailModal(false);
        setEmailSent(false);
        setEmail('');
      }, 2000);
    }
  };

  return (
    <div className="min-h-screen bg-black">
      <Navbar />
      <div className="pt-16">
        {/* Header */}
        <div className="px-6 py-16 bg-gradient-to-r from-black via-gray-900 to-black border-b border-white/10">
          <div className="max-w-4xl mx-auto text-center">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-cyan-500/10 border border-cyan-500/30 rounded-full mb-6 backdrop-blur-sm">
              <i className="ri-book-open-fill text-cyan-400"></i>
              <span className="text-cyan-400 text-sm font-semibold">
                Technical Documentation
              </span>
            </div>
            <h1 className="text-3xl md:text-4xl font-black mb-6 bg-gradient-to-r from-white to-gray-400 bg-clip-text text-transparent">
              PepCoin Whitepaper
            </h1>
            <p className="text-lg text-gray-400 max-w-2xl mx-auto">
              Deep dive into PepCoin's revolutionary architecture – where
              artificial intelligence meets blockchain innovation to create the
              future of automated wealth.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center mt-8">
              <button
                onClick={handleDownloadPDF}
                disabled={isGeneratingPDF}
                className="px-6 py-3 bg-gradient-to-r from-cyan-500 to-purple-600 rounded-lg font-semibold text-white hover:scale-105 transition-all duration-300 cursor-pointer whitespace-nowrap disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {isGeneratingPDF ? (
                  <>
                    <i className="ri-loader-4-line mr-2 animate-spin"></i>
                    Generating PDF...
                  </>
                ) : (
                  <>
                    <i className="ri-download-line mr-2"></i>
                    Download PDF
                  </>
                )}
              </button>
              <button
                onClick={() => setShowShareModal(true)}
                className="px-6 py-3 bg-white/5 border border-white/20 rounded-lg font-semibold text-white hover:bg-white/10 transition-all duration-300 cursor-pointer whitespace-nowrap"
              >
                <i className="ri-share-line mr-2"></i>
                Share Document
              </button>
            </div>
          </div>
        </div>

        {/* Content */}
        <div className="max-w-4xl mx-auto px-6 py-12">
          {/* Table of Contents */}
          <div className="p-6 bg-gradient-to-br from-white/10 to-white/5 backdrop-blur-xl border border-white/10 rounded-2xl mb-12">
            <h2 className="text-xl font-bold text-white mb-4 flex items-center gap-2">
              <i className="ri-list-unordered text-cyan-400"></i>
              Table of Contents
            </h2>
            <div className="grid md:grid-cols-2 gap-3">
              {sections.map((section, idx) => {
                const sectionIcons = [
                  'ri-file-text-line', // Executive Summary
                  'ri-code-box-line', // Technology Stack
                  'ri-coins-line', // Tokenomics
                  'ri-robot-line', // AI Trading System
                  'ri-exchange-line', // P2P & Payment Gateway
                  'ri-shield-check-line', // Security Framework
                  'ri-roadmap-line', // Roadmap
                ];
                
                return (
                  <button
                    key={idx}
                    className="text-left p-3 text-gray-300 hover:text-cyan-400 hover:bg-cyan-500/10 rounded-lg transition-all duration-300 cursor-pointer flex items-center gap-3"
                  >
                    <div className="w-8 h-8 flex items-center justify-center bg-gradient-to-br from-cyan-500/20 to-purple-600/20 rounded-lg">
                      <i className={`${sectionIcons[idx]} text-cyan-400`}></i>
                    </div>
                    <div className="flex-1">
                      <span className="text-gray-400 font-mono text-sm mr-3">
                        {(idx + 1).toString().padStart(2, '0')}
                      </span>
                      {section.title}
                    </div>
                  </button>
                );
              })}
            </div>
          </div>

          {/* Sections */}
          <div className="space-y-12">
            {sections.map((section, idx) => (
              <div
                key={idx}
                className="p-8 bg-gradient-to-br from-white/10 to-white/5 backdrop-blur-xl border border-white/10 rounded-2xl"
              >
                <div className="flex items-center gap-4 mb-6">
                  <div className="w-12 h-12 flex items-center justify-center bg-gradient-to-br from-cyan-500 to-purple-600 rounded-xl">
                    <span className="text-white font-bold">{idx + 1}</span>
                  </div>
                  <h2 className="text-2xl font-bold text-white">
                    {section.title}
                  </h2>
                </div>
                <p className="text-gray-300 leading-relaxed mb-6">
                  {section.content}
                </p>

                {/* Additional content based on section */}
                {section.title === 'Tokenomics' && (
                  <div className="grid md:grid-cols-2 gap-6 mt-6">
                    <div className="p-4 bg-black/30 rounded-xl">
                      <h4 className="text-white font-semibold mb-3">
                        Token Distribution
                      </h4>
                      <div className="space-y-2 text-sm">
                        <div className="flex justify-between">
                          <span className="text-gray-400">Public Sale</span>
                          <span className="text-white">40%</span>
                        </div>
                        <div className="flex justify-between">
                          <span className="text-gray-400">Staking Rewards</span>
                          <span className="text-white">25%</span>
                        </div>
                        <div className="flex justify-between">
                          <span className="text-gray-400">Team & Development</span>
                          <span className="text-white">15%</span>
                        </div>
                        <div className="flex justify-between">
                          <span className="text-gray-400">Liquidity Pool</span>
                          <span className="text-white">10%</span>
                        </div>
                      </div>
                    </div>
                    <div className="p-4 bg-black/30 rounded-xl">
                      <h4 className="text-white font-semibold mb-3">
                        Key Metrics
                      </h4>
                      <div className="space-y-2 text-sm">
                        <div className="flex justify-between">
                          <span className="text-gray-400">Total Supply</span>
                          <span className="text-white">1B PEP</span>
                        </div>
                        <div className="flex justify-between">
                          <span className="text-gray-400">Transaction Fee</span>
                          <span className="text-white">1%</span>
                        </div>
                        <div className="flex justify-between">
                          <span className="text-gray-400">Staking APR</span>
                          <span className="text-white">8-15%</span>
                        </div>
                        <div className="flex justify-between">
                          <span className="text-gray-400">Burn Rate</span>
                          <span className="text-white">50%</span>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {section.title === 'Technology Stack' && (
                  <div className="grid md:grid-cols-3 gap-4 mt-6">
                    {[
                      { category: 'Frontend', tech: 'React, WebGL, Three.js' },
                      { category: 'Backend', tech: 'Node.js, Python AI' },
                      { category: 'Blockchain', tech: 'Solidity, Web3.js' },
                    ].map((item, techIdx) => (
                      <div
                        key={techIdx}
                        className="p-4 bg-black/30 rounded-xl"
                      >
                        <h4 className="text-cyan-400 font-semibold mb-2 text-sm">
                          {item.category}
                        </h4>
                        <p className="text-gray-300 text-sm">{item.tech}</p>
                      </div>
                    ))}
                  </div>
                )}

                {section.title === 'P2P & Payment Gateway' && (
                  <div className="grid md:grid-cols-2 gap-4 mt-6">
                    <div className="p-4 bg-black/30 rounded-xl">
                      <h4 className="text-white font-semibold mb-3">
                        P2P Features
                      </h4>
                      <div className="space-y-2 text-sm">
                        <div className="flex items-center gap-2">
                          <i className="ri-checkbox-circle-fill text-cyan-400"></i>
                          <span className="text-gray-300">
                            Smart Contract Escrow
                          </span>
                        </div>
                        <div className="flex items-center gap-2">
                          <i className="ri-checkbox-circle-fill text-cyan-400"></i>
                          <span className="text-gray-300">150+ Payment Methods</span>
                        </div>
                        <div className="flex items-center gap-2">
                          <i className="ri-checkbox-circle-fill text-cyan-400"></i>
                          <span className="text-gray-300">Reputation System</span>
                        </div>
                        <div className="flex items-center gap-2">
                          <i className="ri-checkbox-circle-fill text-cyan-400"></i>
                          <span className="text-gray-300">Dispute Resolution</span>
                        </div>
                      </div>
                    </div>
                    <div className="p-4 bg-black/30 rounded-xl">
                      <h4 className="text-white font-semibold mb-3">
                        Payment Gateway
                      </h4>
                      <div className="space-y-2 text-sm">
                        <div className="flex items-center gap-2">
                          <i className="ri-checkbox-circle-fill text-purple-400"></i>
                          <span className="text-gray-300">HD Wallet Addresses</span>
                        </div>
                        <div className="flex items-center gap-2">
                          <i className="ri-checkbox-circle-fill text-purple-400"></i>
                          <span className="text-gray-300">Auto Fiat Conversion</span>
                        </div>
                        <div className="flex items-center gap-2">
                          <i className="ri-checkbox-circle-fill text-purple-400"></i>
                          <span className="text-gray-300">Real-time Notifications</span>
                        </div>
                        <div className="flex items-center gap-2">
                          <i className="ri-checkbox-circle-fill text-purple-400"></i>
                          <span className="text-gray-300">API Integration</span>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>

          {/* Executive Leadership Section */}
          <div className="mt-16 mb-16">
            <div className="text-center mb-12">
              <div className="inline-flex items-center gap-2 px-4 py-2 bg-cyan-500/10 border border-cyan-500/30 rounded-full mb-6 backdrop-blur-sm">
                <i className="ri-team-fill text-cyan-400"></i>
                <span className="text-cyan-400 text-sm font-semibold">
                  Leadership Team
                </span>
              </div>
              <h2 className="text-3xl md:text-4xl font-black mb-4 bg-gradient-to-r from-white to-gray-400 bg-clip-text text-transparent">
                Executive Leadership
              </h2>
              <p className="text-gray-400 max-w-2xl mx-auto">
                Meet the visionary leaders driving PepCoin's innovation and growth. Our executive team brings decades of combined experience in blockchain technology, finance, and strategic leadership.
              </p>
            </div>

            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
              {[
                {
                  name: 'Apostle Edesemi Friday',
                  role: 'Chief Executive Officer',
                  image: 'https://static.readdy.ai/image/58c34b0b112df76c80b184053cb893a8/38fc58291489131989656112b36b8d12.jpeg',
                  gradient: 'from-blue-500 to-purple-600'
                },
                {
                  name: 'Paul Bolu-ebi E.',
                  role: 'Chief Technology Officer',
                  image: 'https://static.readdy.ai/image/58c34b0b112df76c80b184053cb893a8/f7972f8689399ffae10e6de976c9d320.jpeg',
                  gradient: 'from-purple-500 to-indigo-600'
                },
                {
                  name: 'Precious Tariebi E.',
                  role: 'Chief Financial Officer',
                  image: 'https://static.readdy.ai/image/58c34b0b112df76c80b184053cb893a8/34f776202cbee67c92c51e59db12d96d.jpeg',
                  gradient: 'from-emerald-500 to-teal-600'
                },
                {
                  name: 'Douebi Peace E.',
                  role: 'Chief Marketing Officer',
                  image: 'https://static.readdy.ai/image/58c34b0b112df76c80b184053cb893a8/41779874c273d7f448b32872f4cd9cda.jpeg',
                  gradient: 'from-orange-500 to-red-600'
                }
              ].map((member, index) => (
                <div
                  key={index}
                  className="group p-6 bg-gradient-to-br from-white/10 to-white/5 backdrop-blur-xl border border-white/10 rounded-2xl hover:border-cyan-500/30 transition-all duration-300"
                >
                  <div className="flex flex-col items-center text-center">
                    {/* Photo */}
                    <div className="relative mb-4">
                      <div className={`absolute -inset-2 bg-gradient-to-br ${member.gradient} rounded-full opacity-20 blur-xl group-hover:opacity-30 transition-opacity`}></div>
                      <div className="relative w-24 h-24 rounded-full overflow-hidden border-4 border-white/20 shadow-xl">
                        <img
                          src={member.image}
                          alt={member.name}
                          className="w-full h-full object-cover"
                        />
                      </div>
                    </div>

                    {/* Name & Title */}
                    <h3 className="text-xl font-bold text-white mb-1">
                      {member.name}
                    </h3>
                    <p className={`text-sm font-semibold mb-2 bg-gradient-to-r ${member.gradient} bg-clip-text text-transparent`}>
                      {member.role}
                    </p>
                  </div>
                </div>
              ))}
            </div>

            {/* Leadership Values */}
            <div className="mt-12 p-8 bg-gradient-to-br from-white/10 to-white/5 backdrop-blur-xl border border-white/10 rounded-2xl">
              <h3 className="text-2xl font-bold text-white mb-6 text-center">
                Our Leadership Values
              </h3>
              <div className="grid md:grid-cols-4 gap-6">
                <div className="text-center">
                  <div className="w-12 h-12 flex items-center justify-center bg-gradient-to-br from-cyan-500 to-cyan-600 rounded-xl mb-3 mx-auto">
                    <i className="ri-lightbulb-flash-line text-xl text-white"></i>
                  </div>
                  <h4 className="text-white font-semibold mb-2">Innovation</h4>
                  <p className="text-gray-400 text-sm">Pioneering blockchain solutions</p>
                </div>

                <div className="text-center">
                  <div className="w-12 h-12 flex items-center justify-center bg-gradient-to-br from-purple-500 to-purple-600 rounded-xl mb-3 mx-auto">
                    <i className="ri-shield-check-line text-xl text-white"></i>
                  </div>
                  <h4 className="text-white font-semibold mb-2">Integrity</h4>
                  <p className="text-gray-400 text-sm">Transparent and ethical leadership</p>
                </div>

                <div className="text-center">
                  <div className="w-12 h-12 flex items-center justify-center bg-gradient-to-br from-emerald-500 to-emerald-600 rounded-xl mb-3 mx-auto">
                    <i className="ri-team-line text-xl text-white"></i>
                  </div>
                  <h4 className="text-white font-semibold mb-2">Community</h4>
                  <p className="text-gray-400 text-sm">Building strong partnerships</p>
                </div>

                <div className="text-center">
                  <div className="w-12 h-12 flex items-center justify-center bg-gradient-to-br from-orange-500 to-orange-600 rounded-xl mb-3 mx-auto">
                    <i className="ri-line-chart-line text-xl text-white"></i>
                  </div>
                  <h4 className="text-white font-semibold mb-2">Growth</h4>
                  <p className="text-gray-400 text-sm">Continuous improvement</p>
                </div>
              </div>
            </div>
          </div>

          {/* Download Section */}
          <div className="mt-16 p-8 bg-gradient-to-br from-cyan-500/10 to-purple-500/10 border border-cyan-500/30 rounded-2xl text-center">
            <h3 className="text-2xl font-bold text-white mb-4">
              Get the Complete Whitepaper
            </h3>
            <p className="text-gray-300 mb-6 text-sm">
              Download the full technical documentation with detailed architecture
              diagrams, code examples, security audits, and complete
              implementation roadmap.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button
                onClick={handleDownloadPDF}
                disabled={isGeneratingPDF}
                className="px-6 py-3 bg-gradient-to-r from-cyan-500 to-purple-600 rounded-lg font-semibold text-white hover:scale-105 transition-all duration-300 cursor-pointer whitespace-nowrap disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {isGeneratingPDF ? (
                  <>
                    <i className="ri-loader-4-line mr-2 animate-spin"></i>
                    Generating PDF...
                  </>
                ) : (
                  <>
                    <i className="ri-file-pdf-line mr-2"></i>
                    Download PDF (2.5MB)
                  </>
                )}
              </button>
              <button
                onClick={() => setShowEmailModal(true)}
                className="px-6 py-3 bg-white/5 border border-white/20 rounded-lg font-semibold text-white hover:bg-white/10 transition-all duration-300 cursor-pointer whitespace-nowrap"
              >
                <i className="ri-mail-line mr-2"></i>
                Email to Me
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Share Modal */}
      {showShareModal && (
        <div className="fixed inset-0 bg-black/80 backdrop-blur-sm flex items-center justify-center z-50 px-4">
          <div className="bg-gradient-to-br from-gray-900 to-black border border-white/20 rounded-2xl p-8 max-w-md w-full">
            <div className="flex justify-between items-center mb-6">
              <h3 className="text-2xl font-bold text-white">
                Share Whitepaper
              </h3>
              <button
                onClick={() => setShowShareModal(false)}
                className="w-8 h-8 flex items-center justify-center text-gray-400 hover:text-white transition-colors cursor-pointer"
              >
                <i className="ri-close-line text-xl"></i>
              </button>
            </div>

            <div className="grid grid-cols-2 gap-4 mb-6">
              <button
                onClick={() => handleShare('twitter')}
                className="p-4 bg-white/5 border border-white/10 rounded-xl hover:bg-white/10 transition-all duration-300 cursor-pointer group"
              >
                <i className="ri-twitter-x-fill text-3xl text-gray-400 group-hover:text-white mb-2"></i>
                <p className="text-sm text-gray-400 group-hover:text-white">
                  Twitter
                </p>
              </button>

              <button
                onClick={() => handleShare('facebook')}
                className="p-4 bg-white/5 border border-white/10 rounded-xl hover:bg-white/10 transition-all duration-300 cursor-pointer group"
              >
                <i className="ri-facebook-fill text-3xl text-gray-400 group-hover:text-blue-500 mb-2"></i>
                <p className="text-sm text-gray-400 group-hover:text-white">
                  Facebook
                </p>
              </button>

              <button
                onClick={() => handleShare('linkedin')}
                className="p-4 bg-white/5 border border-white/10 rounded-xl hover:bg-white/10 transition-all duration-300 cursor-pointer group"
              >
                <i className="ri-linkedin-fill text-3xl text-gray-400 group-hover:text-blue-400 mb-2"></i>
                <p className="text-sm text-gray-400 group-hover:text-white">
                  LinkedIn
                </p>
              </button>

              <button
                onClick={() => handleShare('telegram')}
                className="p-4 bg-white/5 border border-white/10 rounded-xl hover:bg-white/10 transition-all duration-300 cursor-pointer group"
              >
                <i className="ri-telegram-fill text-3xl text-gray-400 group-hover:text-cyan-400 mb-2"></i>
                <p className="text-sm text-gray-400 group-hover:text-white">
                  Telegram
                </p>
              </button>

              <button
                onClick={() => handleShare('whatsapp')}
                className="p-4 bg-white/5 border border-white/10 rounded-xl hover:bg-white/10 transition-all duration-300 cursor-pointer group"
              >
                <i className="ri-whatsapp-fill text-3xl text-gray-400 group-hover:text-green-400 mb-2"></i>
                <p className="text-sm text-gray-400 group-hover:text-white">
                  WhatsApp
                </p>
              </button>

              <a
                href="#"
                className="group flex flex-col items-center p-6 bg-slate-800/50 rounded-xl hover:bg-slate-700/50 transition-all duration-300 cursor-pointer"
              >
                <i className="ri-linkedin-fill text-3xl text-gray-400 group-hover:text-blue-400 mb-2"></i>
                <p className="text-sm text-gray-400 group-hover:text-white">
                  LinkedIn
                </p>
              </a>
              <a
                href="#"
                className="group flex flex-col items-center p-6 bg-slate-800/50 rounded-xl hover:bg-slate-700/50 transition-all duration-300 cursor-pointer"
              >
                <i className="ri-tiktok-fill text-3xl text-gray-400 group-hover:text-white mb-2"></i>
                <p className="text-sm text-gray-400 group-hover:text-white">
                  TikTok
                </p>
              </a>
            </div>

            <button
              onClick={() => handleShare('copy')}
              className="w-full p-4 bg-gradient-to-r from-cyan-500 to-purple-600 rounded-xl font-semibold text-white hover:scale-105 transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-file-copy-line mr-2"></i>
              {shareSuccess ? 'Link Copied!' : 'Copy Link'}
            </button>
          </div>
        </div>
      )}

      {/* Email Modal */}
      {showEmailModal && (
        <div className="fixed inset-0 bg-black/80 backdrop-blur-sm flex items-center justify-center z-50 px-4">
          <div className="bg-gradient-to-br from-gray-900 to-black border border-white/20 rounded-2xl p-8 max-w-md w-full">
            <div className="flex justify-between items-center mb-6">
              <h3 className="text-2xl font-bold text-white">Email Whitepaper</h3>
              <button
                onClick={() => setShowEmailModal(false)}
                className="w-8 h-8 flex items-center justify-center text-gray-400 hover:text-white transition-colors cursor-pointer"
              >
                <i className="ri-close-line text-xl"></i>
              </button>
            </div>

            {!emailSent ? (
              <form onSubmit={handleEmailSubmit}>
                <p className="text-gray-400 mb-4 text-sm">
                  Enter your email address and we'll send you the complete PepCoin
                  whitepaper PDF.
                </p>

                <div className="mb-6">
                  <label className="block text-sm font-semibold text-white mb-2">
                    Email Address
                  </label>
                  <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="your@email.com"
                    required
                    className="w-full px-4 py-3 bg-white/5 border border-white/20 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:border-cyan-500 transition-colors text-sm"
                  />
                </div>

                <button
                  type="submit"
                  className="w-full px-6 py-3 bg-gradient-to-r from-cyan-500 to-purple-600 rounded-lg font-semibold text-white hover:scale-105 transition-all duration-300 cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-send-plane-fill mr-2"></i>
                  Send Whitepaper
                </button>
              </form>
            ) : (
              <div className="text-center py-8">
                <div className="w-16 h-16 flex items-center justify-center bg-gradient-to-br from-cyan-500 to-purple-600 rounded-full mx-auto mb-4">
                  <i className="ri-check-line text-3xl text-white"></i>
                </div>
                <h4 className="text-xl font-bold text-white mb-2">
                  Email Sent!
                </h4>
                <p className="text-gray-400 text-sm">
                  Check your inbox for the PepCoin whitepaper PDF.
                </p>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
